import React from 'react';
import { motion } from 'framer-motion';
import { openWhatsApp } from '../utils/whatsapp';
export function Hero() {
  const handleWhatsApp = () => {
    openWhatsApp();
  };
  return <section id="inicio" className="relative min-h-[100vh] md:min-h-screen flex items-center justify-center overflow-hidden py-24 md:py-0" data-id="element-173">
      {/* Background Image */}
      <div className="absolute inset-0 z-0" data-id="element-174">
        <img src="https://cdn.magicpatterns.com/uploads/93wHV4vU4gxZDL57tG7bFa/EL_MIRADOR_VISTA_PANORAMICA_1.jpg" alt="Vista panorámica del valle y el río en El Durazno" className="w-full h-full object-cover object-center" data-id="element-175" />
        {/* Overlay */}
        <div className="absolute inset-0 bg-black/40" data-id="element-176"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-177"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 max-w-4xl mx-auto mt-12 md:mt-20" data-id="element-178">
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-5xl md:text-7xl lg:text-8xl text-white mb-6 drop-shadow-lg" data-id="element-179">
          Cabañas El Mirador
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-lg md:text-xl lg:text-2xl text-white/95 mb-10 font-light max-w-2xl mx-auto drop-shadow-md leading-relaxed" data-id="element-180">
          Descansá rodeado de naturaleza y disfrutá una vista única del valle en
          El Durazno, Yacanto de Calamuchita, Córdoba.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="flex flex-col items-center justify-center gap-4" data-id="element-181">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 w-full flex-wrap" data-id="element-182">
            <button onClick={handleWhatsApp} className="w-full sm:w-auto px-8 py-4 bg-olive text-white rounded-full font-medium text-lg hover:bg-olive-dark transition-colors shadow-lg" data-id="element-183">
              Reservá por WhatsApp
            </button>
            <a href="#cabanas" className="w-full sm:w-auto px-8 py-4 bg-white/10 backdrop-blur-md text-white border border-white/30 rounded-full font-medium text-lg hover:bg-white hover:text-olive-dark transition-all shadow-lg" data-id="element-184">
              Ver cabañas
            </a>
            <a href="https://www.instagram.com/cabanas_mirador/" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-4 bg-white/10 backdrop-blur-md text-white border border-white/30 rounded-full font-medium text-lg hover:bg-white hover:text-olive-dark transition-all shadow-lg" data-id="element-185">
              Nuestras promociones
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}